import { ITypedCommandEvent } from '../../FrontApplet/Command/ICommandEvent';
import ICommand from '../../FrontApplet/Command/ICommand';
import FrontApplet from '../../FrontApplet/FrontApplet';
import {
	DeviceInfoGetDeviceNameRequest,
	DeviceInfoGetDeviceNameResult,
	DeviceInfoGetLocationRequest,
	DeviceInfoGetLocationResult,
	DeviceInfoGetOrganizationTagsRequest,
	DeviceInfoGetOrganizationTagsResult,
	DeviceInfoRequests,
} from './deviceInfoCommands';

export function handleDeviceInfoRequests(
	onCommand: (callback: (commandEvent: ITypedCommandEvent<DeviceInfoRequests>) => Promise<void>) => void,
	dispatch: <TCommand extends ICommand>(command: TCommand) => Promise<void>,
	frontApplet: FrontApplet,
) {
	onCommand(async (commandEvent: ITypedCommandEvent<DeviceInfoRequests>) => {
		switch (commandEvent.command.type) {
			case DeviceInfoGetLocationRequest:
				await dispatch<DeviceInfoGetLocationResult>({
					type: DeviceInfoGetLocationResult,
					result: await frontApplet.deviceInfo.getLocation(),
				});
				break;
			case DeviceInfoGetOrganizationTagsRequest:
				await dispatch<DeviceInfoGetOrganizationTagsResult>({
					type: DeviceInfoGetOrganizationTagsResult,
					result: await frontApplet.deviceInfo.getOrganizationTags(),
				});
				break;
			case DeviceInfoGetDeviceNameRequest:
				await dispatch<DeviceInfoGetDeviceNameResult>({
					type: DeviceInfoGetDeviceNameResult,
					result: await frontApplet.deviceInfo.getDeviceName(),
				});
				break;
			default:
		}
	});
}
